import { PhaseString } from "types/global";
import { Day } from "types/Recipe";


/**
 * Utilizzato per la visualizzazione di un gruppo-phase di DAYs del recipe
 */
export interface GroupPhase {
	/** la PHASE selezionata */
	phase: PhaseString
	/** indica che il gruppo è visualizzato collassato o no */
	collapsed: boolean
	/** i giorni di questa fase */
	days: Day[]
	/** i giorni selezionati usato in recipe */
	daysSelect?: number[]

	// POLICY
	shrink?: Policy
	expand?: Policy
}

export type Policy = {
	name: POLICY_NAMES
	dayRef?: number
}

export enum POLICY_NAMES {
	DEFAULT = "default",
	KEEP = "keep_from"
}

export const tooltipsSchrink: {
	[key in POLICY_NAMES]: string
} = {
	[POLICY_NAMES.DEFAULT]: "It shrinks by cutting from the last day",
	[POLICY_NAMES.KEEP]: "First delete in descending order from the left side and if necessary delete in ascending order from the right side of the selected day"
}

export const tooltipsExpand: {
	[key in POLICY_NAMES]: string
} = {
	[POLICY_NAMES.DEFAULT]: "Expands the cycle by copying the last day of the recipe",
	[POLICY_NAMES.KEEP]: "Expands the cycle by copying the selected day of the recipe"
}
